import { PopularRanking, Statistics } from "../../models/statistics";
import { AppAction } from "../../root/AppAction";
import StatisticsEvent from "../events/StatisticsEvent";
/* 統計情報レデューサー */
export interface StatisticsStore {
    statistics: Statistics | undefined;
    popularRanking: PopularRanking | undefined;
    isLoading: boolean;
}

/* 統計情報レデューサー初期値設定 */
const initialStatisticStore: StatisticsStore = {
    statistics: undefined,
    popularRanking: undefined,
    isLoading: false,
};

export function statistics(state: StatisticsStore = initialStatisticStore, action: AppAction) {
    switch (action.type) {
        //統計情報取得
        case StatisticsEvent.GetStatisticsStarted:
            return {
                ...state,
                isLoading: true,
            };
        case StatisticsEvent.GetStatisticsCompleted:
            return {
                ...state,
                statistics: action.statistics,
                isLoading: false,
            };
        //ランキング情報取得
        case StatisticsEvent.GetPopularRankingStarted:
            return {
                ...state,
                isLoading: true,
            };
        case StatisticsEvent.GetPopularRankingCompleted:
            return {
                ...state,
                popularRanking: action.popularRanking,
                isLoading: false,
            };
        //統計情報取得
        case StatisticsEvent.GetDocumentStatisticsStarted:
            return {
                ...state,
                isLoading: true,
            };
        case StatisticsEvent.GetDocumentStatisticsCompleted:
            return {
                ...state,
                statistics: action.statistics,
                isLoading: false,
            };
        //ランキング情報取得
        case StatisticsEvent.GetDocumentPopularRankingStarted:
            return {
                ...state,
                isLoading: true,
            };
        case StatisticsEvent.GetDocumentPopularRankingCompleted:
            return {
                ...state,
                popularRanking: action.popularRanking,
                isLoading: false,
            };
        // 統計情報の登録(ドキュメント）
        case StatisticsEvent.SaveDocumentStatisticsStarted:
            return {
                ...state,
                isLoading: true,
            };
        case StatisticsEvent.SaveDocumentStatisticsCompleted:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}

export default statistics;
